import React from 'react'
// import ReactDOM from 'react-dom'
import Modal from 'react-modal'
import Title from '../title/title'
import Container from '@mui/material/Container'
import Tooltip from '@mui/material/Tooltip'

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)'
  }
}

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
// Modal.setAppElement('#yourAppElement')

const ShowModal = ({ img, name, title, id, children }) => {
  const [modalIsOpen, setIsOpen] = React.useState(false)

  const openModal = () => {
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  let mod = ''

  if (typeof document !== 'undefined') {
    mod = document.getElementById({ id })
  }
  return (
    <>
      <Tooltip title={`${name} - ${title}`}>
        <img
          src={img}
          onClick={openModal}
          id={id}
          className='isHoverable mb-3'
          style={{ width: '100%' }}
        />
      </Tooltip>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel='Example Modal'
        appElement={mod}
      >
        <Container maxWidth='lg'>
          <div className='row'>
            <div className='col-md-4'>
              <img src={img} onClick={openModal} style={{ width: '100%' }} />
            </div>
            <div className='col-md-8'>
              <Title h2={name} h4={title} />
              {children}
            </div>
          </div>

          <button style={{ background: '#0a3758', color: '#ffffff', border: '0', borderRadius: '5px', padding: '5px 10px' }} onClick={closeModal}>Close</button>
        </Container>
      </Modal>
    </>
  )
}

export default ShowModal
